import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import AppContext from '../AppContext';

function ThemeToggler(props) {
  const { onClick } = props;
  const { isDarkMode, toggleTheme } = useContext(AppContext);

  const handleToggle = () => {
    toggleTheme();
    onClick();
  };

  return (
    <button
      type="button"
      className={['theme-toggle', isDarkMode ? 'is-active' : ''].filter(Boolean).join(' ')}
      onClick={handleToggle}
      aria-label="Toggle color theme"
      aria-pressed={isDarkMode}
    >
      <span className="theme-toggle__thumb" aria-hidden="true" />
      <span className="theme-toggle__label">{isDarkMode ? 'Night' : 'Day'}</span>
    </button>
  );
}

ThemeToggler.propTypes = {
  onClick: PropTypes.func,
};
ThemeToggler.defaultProps = {
  onClick: () => {},
};

export default ThemeToggler;
